import { Component, OnInit, Input, Injectable } from '@angular/core';
import { MsgTemplateAutoMatch } from '../../msg-interface/msg-template-auto-match';
import { _MSGTYPES } from '../../shared/constant/msgType';

@Component({
  selector: 'app-voice-tpl-auto-match',
  templateUrl: './voice-tpl-auto-match.component.html',
  styles: [],
})
export class VoiceTplAutoMatchComponent implements OnInit, MsgTemplateAutoMatch {
  constructor() {}
  @Input() tplList: any[];
  viewList: any;
  type = _MSGTYPES.MT.VOICE.type;

  ngOnInit() {
    this.viewList = this.parseData();
  }

  /* 数据解析 */
  parseData() {
    return this.tplList;
  }
}
